import { useEffect } from 'react';
import { touchControls } from '../utils';

export function useTouchControls() {
  useEffect(() => {
    touchControls.initialize();

    const callbacks = {
      touchstart: touchControls.handleTouchStart,
      touchend: touchControls.handleTouchEnd,
      touchmove: touchControls.handleTouchMove,
    };

    for (const [eventName, callback] of Object.entries(callbacks)) {
      window.addEventListener(eventName, callback);
    }
    return () => {
      for (const [eventName, callback] of Object.entries(callbacks)) {
        window.removeEventListener(eventName, callback);
      }
    };
  }, []);

  const { addListener } = touchControls;

  return { addListener };
}
